export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'マイン',
  frontPageProvideTitle: 'サプライ',
  frontPagePersonalCenterTitle: 'プロフィール',
  login: 'ログイン',
  home_chatWithOctopie: 'あなたの考えを理解しています',
  home_chatNeedUnderstood: 'あなたの考えを理解しました',
  home_draftBannerTitle: 'メッセージを仕上げましょう',
  home_draftBannerSubtitle: 'AIがメッセージをまとめました — タップして続けましょう',
  home_tabHome: 'ホーム',

  // App.vue
  appRequirementTitle: 'ご意見・ご要望をすべて大切にお聞きします',
  appRequirementBtn: '送信',
  appSubmitSuccess: '送信しました。フィードバックありがとうございます',
  appFeedbackLink: 'ご意見・ご要望',
  mobile_banner_text: '最高の体験のために、アプリをご利用ください',
  mobile_banner_btn: 'アプリを入手',

  // Common
  loading: '読み込み中...',
  confirm: '確認',
  cancel: 'キャンセル',
  save: '保存',
  delete: '削除',
  edit: '編集',
  add: '追加',
  search: '検索',
  refresh: '更新',
  change_batch: 'シャッフル',
  back: '戻る',
  submit: '送信',
  close: '閉じる',
  ok: 'OK',
  yes: 'はい',
  no: 'いいえ',
  send: '送信',
  block: 'ブロック',
  more: 'もっと見る',
  logout: 'ログアウト',
  settings: '設定',
  view_guide: 'ガイドを見る',
  feedback: 'フィードバック',
  feedback_title: 'フィードバック',
  feedback_new: '新規フィードバック',
  feedback_empty: 'フィードバックはまだありません',
  feedback_hint: 'ご意見をお聞かせください...',
  feedback_submit: '送信',
  feedback_submit_success: 'フィードバックを送信しました',
  feedback_submit_failed: 'フィードバックの送信に失敗しました',
  feedback_reply_label: '運営からの返信',
  register: '登録',
  name: '名前',
  email: 'メールアドレス',
  mobile: '電話番号',
  password: 'パスワード',
  verification_code: '認証コード',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: '著作権所有',
  footerVersion: 'バージョン {version}',
  copy: 'コピー',
  regenerate: '再生成',
  generate: '生成',
  contact_now: 'チャット',
  yours: 'あなた',
  xiaoyao_analysis: 'AI分析',
  brand_name: 'OctoSay',
  anonymous: '匿名',
  no_summary: 'サマリーなし',
  file: 'ファイル',
  discover: '発見',
  discover_title: '発見',
  discover_hotChannels: '人気のチャンネル',
  discover_allChannels: 'すべて',
  discover_searchChannel: 'チャンネルを検索',
  discover_noChannels: 'チャンネルが見つかりません',

  // Messages
  operationSuccess: '操作が完了しました',
  operationFailed: '操作に失敗しました',
  networkError: 'ネットワークエラーです。後でもう一度お試しください',
  dataLoadingFailed: 'データの読み込みに失敗しました',
  noData: 'データがありません',
  deleteConfirm: '削除してもよろしいですか？',
  saveConfirm: '保存してもよろしいですか？',

  // Form Validation
  required: 'この項目は必須です',
  emailInvalid: '有効なメールアドレスを入力してください',
  phoneInvalid: '有効な電話番号を入力してください',
  passwordTooShort: 'パスワードは{min}文字以上で入力してください',
  passwordMismatch: 'パスワードが一致しません',

  // Time
  today: '今日',
  yesterday: '昨日',
  justNow: 'たった今',
  minutesAgo: '{min}分前',
  hoursAgo: '{hour}時間前',
  daysAgo: '{day}日前',

  // Footer
  about: 'このアプリについて',
  footerPrivacy: 'プライバシーポリシー',
  footerTerms: '利用規約',
  footerSupport: 'サポート',

  // Register
  registerAgeConfirm: '13歳以上であることを確認します',
  registerAgeConfirm18: '私は18歳以上であることを確認します',
  registerTermsPrefix: '以下を読み、同意しました',
  registerTermsAnd: 'と',
  registerAgeError: '年齢を確認してください',
  registerTermsError: '利用規約とプライバシーポリシーに同意してください',

  // Chat
  chatPrivacyTip: 'ハブでメッセージを入力すると、AIがまずチャットで詳細を確認します。確認後、あなたのメッセージとAIサマリーが一緒に投稿され、AIが継続的にマッチを探します。',
  aiChat_quickSuggestions: 'こんな感じでいかが？',
  aiChat_welcome: "やあ！何を探しているのか教えてね。",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: '詳細を理解しました。投稿するとマッチを探します',
  aiChat_readyToPostHint: '投稿後も、詳細を追加したいときはいつでも AI とチャットを続けられます',
  aiChat_progressStep1: '詳細を理解',
  aiChat_progressStep1Done: '詳細を理解しました',
  aiChat_progressStep2: 'AIサマリー',
  aiChat_progressStep2Desc: 'AIがマッチング用のサマリーを作成します',
  aiChat_progressStep3: 'ハブに投稿',
  aiChat_progressStep3Desc: '投稿してマッチを探します',
  aiChat_publishExtraHint: 'ハブのみんなに伝えたいことを入力してください',
  aiChat_publishMsgRequired: '必須',
  aiChat_publishMsgLabel: 'ハブのみんなに伝えたいこと',
  aiChat_matchSummaryLabel: 'AIサマリー',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: '以下のコンテンツは AI が生成したものであり、参考情報です',
  aiChat_publishSuggestionHint: 'タップして置き換え',
  aiChat_allowDirectContact: '直接の連絡を許可',
  aiChat_allowDirectContactDesc: 'マッチしなくても、他の人があなたに直接連絡できます',
  channel_chat_session_publishToChannel: 'Octoグループ に投稿',
  aiChat_newChat: 'リセット',

  // Channels / グループ
  home_tabChannels: 'Octoグループ',
  channels_title: 'Octoグループ',
  channels_myChannels: '参加中のハブ',
  channels_discover: '発見',
  channels_noChannels: 'ハブがまだありません',
  channels_noMyGroupsTitle: 'まだどのハブにも参加していません',
  channels_noMyGroupsSubtitle: 'ハブを検索して参加して、新しい出会いを始めましょう',
  channels_searchGroupsBtn: 'ハブを検索',
  channels_loginPrompt: 'ログインしてハブを表示',
  channels_create: 'Octoグループ を作成',
  channels_search: 'Octoグループ を検索',
  channels_searchMyGroups: '自分の Octoグループ を検索',
  channels_searchHint: '検索',
  channels_searchHintChats: 'チャットを検索...',
  channels_searchHintGroups: 'ハブを検索...',
  channels_searchHintMy: '参加中のハブを検索...',
  channels_joinByCode: 'コードで参加',
  channels_joinByCodeTitle: 'コードで Octoグループ に参加',
  channels_joinByCodeHint: 'Octoグループ コードを入力',
  channels_joinByCodeConfirm: '参加',
  channels_joinByCodeNotFound: 'ハブが見つかりません',
  channels_createNewGroup: '新しい Octoグループ を作成',
  channels_noResults: 'ハブが見つかりません',
  channel_detail_join: '参加',
  channel_detail_leave: '退出',
  channel_detail_members: 'メンバー',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} が参加しました',
  channelJoinMsg_twoJoined: '{name1} と {name2} が参加しました',
  channelJoinMsg_multiJoined: '{name1}、{name2} 他 {n} 人が参加しました',
  channelJoinMsg_oneAndMoreJoined: '{name} 他 {n} 人が参加しました',
  channelJoinMsg_membersJoined: '{n} 人が参加しました',

  // Feed
  channels_feed: 'チャット',
  channels_groups: 'ハブ',
  feed_related: '関連',
  feed_recommend: 'おすすめ',
  feed_empty: 'フィードはまだありません。人気のハブをのぞいてみましょう',
  feed_goToGroup: 'ハブで見る',
  feed_joinGroupAndSendMsg: 'ハブに参加してメッセージを送ろう',
  channel_detail_channelCode: 'Octoグループ コード',
  channel_detail_invitePhrase: '「{name}」にご招待\n招待コード {code} · アプリを開くと自動で参加 · AIが先に内容を整理し、相性のいい相手を見つけます',
  channel_detail_post: 'ハブに投稿',
  channel_detail_aiHint: "ハブでメッセージを書くと、AIがまず詳細を確認します",
  channel_input_hint: '何か書いてみましょう…',
  channel_leave_confirm_message: 'このハブを退出しますか？退出するとハブのメッセージは届かなくなります。',
  channel_invite_notFound: 'ハブが存在しないか、リンクの有効期限が切れています',
  channel_invite_joinBtn: 'OctoSay アプリをダウンロード',
  channel_invite_hint: 'アプリをダウンロードして、このQRコードをスキャンするか、ハブ名を検索して参加してください',
  channel_invite_globalHintTitle: 'グローバル版をダウンロードしようとしています',
  channel_invite_globalHintIOS: 'このアプリは中国のApp Storeでは入手できない場合があります。中国以外のApple Storeに切り替えて「OctoSay」を検索するか、下からAPKを直接ダウンロードしてください。',
  channel_invite_globalHintAndroid: 'お使いの地域ではGoogle Playにアクセスできない場合があります。APKを直接ダウンロードするか、Google Playをお試しください。',
  channel_invite_globalHintDefault: 'お使いの地域のアプリストアでは入手できない場合があります。APKを直接ダウンロードするか、App Storeをお試しください。',
  channel_invite_globalBtnAppStore: 'App Store へ',
  channel_invite_globalBtnGooglePlay: 'Google Play へ',
  channel_invite_globalBtnAPK: 'APKを直接ダウンロード',
  channel_invite_defaultDesc: 'OctoSay の {name} に参加',
  share: 'シェア',
  share_channel: 'ハブをシェア',
  share_channel_link: 'リンクをシェア',
  channel_detail_inviteCode: '招待コード',
  channel_detail_copyLink: 'リンクをコピー',
  share_session_title: 'OctoSay の投稿',
  share_match_title: 'OctoSay のマッチ',
  share_session_text: '{userName}：{summary}',
  share_session_text_no_summary: '{userName} が OctoSay に投稿した内容を見てみましょう',
  session_share_notFound: '投稿が存在しないか、リンクの有効期限が切れています',
  session_share_fromChannel: 'Octoグループ から',
  session_share_downloadBtn: 'OctoSay アプリをダウンロード',
  session_share_hint: 'アプリをダウンロードすると、投稿の全文を見てハブに参加できます',
  session_share_openInApp: 'アプリで開く',
  toast_link_copied: 'リンクをコピーしました',
  toast_no_share_data: 'シェアできる内容がありません',
  channels_joinByQR: 'QRコード',
  channels_joinByQRWebHint: 'ウェブ版はQRスキャンに対応していません。ハブコードを入力して参加してください。',
  channels_joinByQRTitle: 'QRコードで参加',
  channel_detail_qrCode: 'QRコード',
  channel_detail_qrCodeSave: '画像を保存',
  channel_detail_qrCodeSaveHint: '画像を右クリックして保存',
  channel_detail_qrCodeSaved: 'アルバムに保存しました',
  channel_detail_qrCodeSaveFailed: '保存に失敗しました。もう一度お試しください',
  channel_detail_locateFailed: 'メッセージを特定できませんでした',
  channel_detail_locateError: 'メッセージの特定でエラーが発生しました',
  channel_detail_myMessages: '自分のメッセージ',
  channel_detail_searchMessages: 'メッセージを検索',
  channel_detail_aiChat: 'AI チャット',
  channel_detail_matchHistory: 'マッチ履歴',
  channel_create_title: 'Octoグループ を作成',
  channel_create_name: 'Octoグループ 名',
  channel_create_description: '説明',
  channel_create_submit: '作成',
  channelCreate_aiAssist: 'AIがあなたに合ったハブ作りをお手伝いします',
  channelCreate_nameHint: 'ハブ名を入力してください',
  channelCreate_descHint: 'ハブの内容を説明してください',
  channelCreate_creating: '作成中...',
  channelCreate_created: 'ハブを作成しました！',
  channelCreate_failed: 'ハブの作成に失敗しました',
  channelCreate_welcomeMsg: "こんにちは！ハブ作成をお手伝いします。どんなハブを作りたいか——テーマや目的など——教えてください。ハブ名と紹介文にまとめ、プロフィール画像も自動で生成しますね。",
  channelCreate_aiHint: 'ハブのテーマを書いてください...',
  channelCreate_clarifyingProgress: 'ハブのテーマを整理中...',
  channelCreate_readyToCreate: 'Octoグループ を作成できます',
  channelCreate_step1: 'テーマを説明',
  channelCreate_step1Done: 'アイデアが明確になりました',
  channelCreate_step2: 'Octoグループ を作成',
  channelCreate_confirmBtn: '作成を確認',
  channelCreate_publicNotice: 'ハブは共通の興味を持つ人々が集まる公開スペースです。プラットフォームは必要に応じてハブを管理・調整・統合できます。興味がありそうな人にハブをシェアしてみてください。',
  channelCreate_similarGroupsTitle: '似ている Octoグループ が見つかりました',
  channelCreate_similarGroupsDesc: 'これらのハブがお探しのものに合うかもしれません',
  channelCreate_exactMatchHint: '同じ名前のハブが既に存在します！',
  channelCreate_joinHint: 'これらの既存ハブが合うかもしれません',
  channelCreate_joinExisting: '既存の Octoグループ に参加',
  channelCreate_stillCreate: 'それでも新しく作成する',
  channel_chat_session_comments: 'コメント',
  channel_chat_session_commentHint: 'コメントを書く...',
  channel_chat_session_sendComment: 'コメント',
  channel_chat_session_loadMore: 'もっと見る',
  channel_chat_session_noComments: 'コメントはまだありません',
  channel_chat_session_deleteComment: '削除',
  channelSearch_title: 'ハブ内を検索',
  channelSearch_placeholder: 'メッセージを検索...',
  channelSearch_onlyMine: '自分の投稿のみ',
  channelSearch_tabAllMessages: 'ハブのメッセージ',
  channelSearch_tabMyMessages: '自分のメッセージ',
  chatMsgSearch_placeholder: 'メッセージを検索',
  chatMsgSearch_tabMsgs: 'メッセージ',
  chatMsgSearch_tabContacts: '連絡先',
  chatMsgSearch_emptyPrompt: 'キーワードを入力してメッセージを検索',
  chatMsgSearch_tooShort: '2文字以上入力して検索してください',
  chatMsgSearch_contactEmptyPrompt: 'ユーザー名またはメールアドレスで連絡先を検索',
  chatMsgSearch_noContacts: '一致する連絡先がありません',
  chatMsgSearch_inChatPlaceholder: 'このチャット内を検索',
  channelHistory_title: '履歴',
  channelHistory_myMessages: '自分のメッセージ',
  channelHistory_loadMore: 'もっと見る',
  channel_settings_push: 'Octoグループ の通知',
  channel_settings_commentPush: 'コメント通知',
  channel_settings_likePush: 'いいね通知',
  channel_settings_receiveNotifications: '通知を受け取る',
  channel_settings_directContact: '直接の連絡を許可',
  session_published: '公開済み',
  session_publishFailed: '公開に失敗しました',
  session_setDirectContactSuccess: '設定を保存しました',
  session_setDirectContactFailed: '設定の保存に失敗しました',
  session_setPrivate: '非公開にする',
  session_setPublic: '公開にする',
  session_pauseMatching: 'マッチングを一時停止',
  session_resumeMatching: 'マッチングを再開',
  session_matchPausedToast: 'マッチングを一時停止しました',
  session_matchResumedToast: 'マッチングを再開しました',
  match_matchingPausedTitle: 'マッチングは一時停止中です',
  match_reasonTag: 'マッチ理由',
  match_matchingPausedHint: 'いつでもマッチングを再開できます。',
  session_confirmSetPrivate: 'このコンテンツを非公開にしますか？他のユーザーは閲覧できなくなります。',
  session_messageIsPrivate: 'このメッセージは非公開です',
  chatSessionComment_replyHint: 'コメントを書く...',
  chatSessionComment_reply: 'コメント',
  chatSessionComment_count: '{n}件のコメント',
  chatSessionMatch_count: '{n}件のマッチ',
  chatSessionComment_replyTo: '返信',
  chatSessionComment_inputHint: 'コメントを書く...',
  chatSessionComment_send: '送信',
  chatSessionComment_delete: '削除',
  chatSessionComment_deleteConfirm: 'このコメントを削除してもよろしいですか？',
  chatSessionComment_loadMore: 'もっと見る',
  chatSessionComment_noMore: 'コメントはこれ以上ありません',
  chatSessionComment_loginToComment: 'コメントするにはログインしてください',
  chatSessionComment_viewEarlier: '以前の返信{n}件を見る',
  chatSessionLike_like: 'いいね',
  chatSessionLike_liked: 'いいね済み',
  chatSessionLike_count: 'いいね',
  chatSessionBookmark_bookmark: 'ブックマーク',
  chatSessionBookmark_bookmarked: 'ブックマーク済み',
  chatSessionMatch_viewMatches: 'マッチを見る',
  chatSessionMatch_matchHistory: 'マッチ履歴',
  chatSessionMatch_noMatches: 'マッチはまだありません',
  channel_match_achievement: '{count}件の投稿がマッチしました',
  channel_match_achievement_view: '見る →',
  channel_matchHistory_title: 'チャンネルのマッチ履歴',
  chatSessionMatch_matchedAt: '{time} にマッチ',
  discover_userMsgLabel: 'この人の投稿',
  common_loading: '読み込み中...',
  common_sending: '送信中...',
  common_error: 'エラー',
  common_success: '成功',
  common_me: '自分',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "AIがニーズを明確にし、投稿するメッセージが確実に届くようにします。投稿後も継続的にマッチングします",
  aiChat_clarifyingAlmostDone: 'もうすぐ完了です。確認してください',
  aiChat_clarifyingOneMore: 'あと1問の回答で投稿できます',
  aiChat_clarifyingRemaining: 'あと{count}ラウンドほどで完了です',
  aiChat_clarifyingEvaluating: '進捗を確認中...',
  aiChat_setPublicMatch: '公開してマッチング',
  aiChat_needsClarifiedPublic: "あなたのことがわかりました。確認して投稿すると、AIが継続的にマッチを探します。\n詳細はいつでも追加で教えてください。",
  aiChat_needsClarifiedPrivate: 'おおよそ理解しました！公開に設定すれば、AIが継続的にマッチを探します！\n詳細はいつでも教えてください。',
  aiChat_setPublicTitle: '公開にする',
  aiChat_setPublicMessage: 'あなたのコンテンツは他の人にも表示され、OctoSay がマッチを探せるようになります。\n\n共有される情報：\n• ユーザー名とアイコン\n• コンテンツのサマリー\n• 会話の内容（発見タブに表示）\n\nいつでも非公開に戻せます。',
  aiChat_findMatches: 'マッチ結果を見る',
  aiChat_publishing: '投稿中...',
  aiChat_matchSectionTitle: 'あなたのメッセージはこのグループが一番合っています — タップして投稿',
  aiChat_joinedBadge: '参加済み',
  aiChat_matchSectionEmpty: 'しっかりマッチするグループがまだありません。新しいグループを作成して投稿できます',
  aiChat_suggestPublishCreateNew: '新しいグループを作成',
  aiChat_repickChannel: 'グループを変更',
  aiChat_creatingChannelTitle: '合うグループが見つからず、作成しています',
  aiChat_creatingChannelHint: 'リクエストに合わせてグループを作成中。完了後そのまま投稿に進みます。通常10〜30秒かかります',
  aiChat_publishToChannelHint: '「{name}」に投稿されます',
  aiChat_pickChannelTitle: '投稿するグループを選択',
  aiChat_matchingChannelTitle: 'ぴったりのグループを探しています',
  aiChat_matchingChannelHint: 'AI があなたのリクエストから検索しています。数秒から30秒ほどかかります',
  aiChat_matchUnavailableTitle: 'おすすめを表示できません',
  aiChat_matchUnavailableHint: '下でグループを検索するか、閉じてからもう一度開いてください',
  aiChat_waitSlowHint: '通常より時間がかかっていますが処理は続いています。もう少々お待ちください。下でグループを検索することもできます',
  aiChat_creatingSlowHint: '通常より時間がかかっていますが、グループを作成中です。もう少々お待ちください。完了後そのまま投稿に進みます',
  aiChat_pickChannelEmptyHint: '関連するグループが見つかりません。新しいグループを作成して投稿しましょう',
  aiChat_loadMore: 'もっと見る',
  sidebar_publish: '投稿する',
  chat_selectLocationOnMap: '地図上で位置を選択してください',

  // App.vue new
  placeholder_email: 'メールアドレスを入力してください',
  placeholder_mobile: '電話番号を入力してください',
  placeholder_password: 'パスワードを入力してください',
  placeholder_name: '名前を入力してください',
  random_nickname: 'ランダム',
  placeholder_verification_code: '認証コードを入力してください',
  sending: '送信中...',
  registering: '登録中...',
  send_code: 'コードを送信',
  retry_in_seconds: '{countdown}秒後に再試行',
  toast_enter_email: 'メールアドレスを入力してください',
  toast_enter_mobile: '電話番号を入力してください',
  toast_invalid_email: '有効なメールアドレス形式で入力してください',
  toast_invalid_mobile: '有効な電話番号を入力してください',
  toast_send_code_failed: '認証コードの送信に失敗しました',
  toast_code_sent: '認証コードをメールに送信しました',
  toast_code_sent_sms: '認証コードを電話番号に送信しました',
  toast_send_code_error: '認証コードの送信に失敗しました。後でもう一度お試しください',
  toast_fill_all_fields: 'すべての項目を入力してください',
  toast_login_failed: 'ログインに失敗しました',
  toast_login_success: 'ログインしました',
  oauthOr: 'または',
  toast_oauth_login_failed: 'Google ログインに失敗しました',
  toast_oauth_login_error: 'Google ログインでエラーが発生しました。もう一度お試しください',
  toast_login_error: 'ログインに失敗しました。後でもう一度お試しください',
  toast_register_failed: '登録に失敗しました',
  toast_register_success: '登録しました',
  toast_register_error: '登録に失敗しました。後でもう一度お試しください',

  // AdBanner.vue
  ad: '広告',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: '接続の前に',
  contactAd_gateSubtitle: 'この短い広告でOctoSayは無料で使い続けられます。ご協力ありがとうございます！',
  contactAd_waitBtn: '{sec}秒後に続行できます',
  contactAd_continueBtn: 'チャットを続ける',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'チャット',

  // AiMatch.vue
  ai_welcome_msg: 'こんにちは、AIです。相棒探し、仲間探し、スキル交換など、何でも話してください。',
  default_username: 'ユーザー',

  // AvatarCropDialog.vue
  crop_hint: 'ピンチで拡大縮小、ドラッグで調整',
  toast_crop_failed: '画像の切り抜きに失敗しました',

  // ChatBox.vue
  loading_match_info: 'マッチ情報を読み込み中...',
  view_match_details: 'マッチ詳細を見る',
  step_clarify_needs: '確認',
  step_ai_matching: 'ハブに投稿',
  step_connect: 'AIマッチング',
  make_private: '非公開にする',
  setting: '設定中...',
  action_photo: '写真',
  action_file: 'ファイル',
  action_video: '動画',
  action_location: '位置情報',
  hint_get_app: 'アプリを入手してつながりを保とう',
  match_finding_title: 'あなたのマッチ',
  match_finding_subtitle: 'AIが継続的にマッチを探しています',
  match_time_hint: 'この処理には通常1〜2分かかります',
  match_result_stats: 'ベストマッチ{matched}件を見つけました{interested}',
  match_tap_to_connect: 'タップして会話を始めましょう',
  match_channel_hint: 'ハブ <strong>#{channel}</strong> でマッチング中。同じハブを優先しますが、必要に応じて他のハブも含まれます。',
  label_perfect_match: 'ベストマッチ',
  label_worth_a_look: '要チェック',
  match_no_result_title: 'マッチを探しています',
  match_no_result_desc: '詳細をもっとシェアすると、OctoSay がマッチを見つけやすくなります。マッチ通知を受け取るにはアプリをインストールしてください。',
  go_back: '戻る',
  no_public_requirements: '公開投稿はまだありません',
  channelEmpty_title: 'まだ何もありません',
  channelEmpty_subtitle: '最初にアイデアをシェアしませんか',
  channelEmpty_hint: "考えを書けば、AIが内容を整理して継続的にマッチングし、メッセージが埋もれません",
  channelEmpty_action: 'あなたのアイデアをシェア',
  stay_connected: 'つながりを保つ',
  download_app_desc: 'アプリを入手するとチャットでき、誰かがつながってきたらすぐ通知を受け取れます！',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APKを直接ダウンロード',
  match_history: 'マッチ履歴',
  no_match_history: 'マッチ履歴はまだありません',
  finding_matches: 'AIが継続的にマッチを探しています - ハブにメッセージを投稿すると開始します',
  discover_connect_hint: 'マッチしたらチャットを始められます！',
  match_initializing: '初期化中...',
  placeholder_login_to_chat: 'ログインして、あなたの考えを教えてください',
  toast_need_clear: 'あなたの考えが明確になりました！',
  toast_ai_responding: 'AIが返信中です。お待ちください...',
  toast_uploading_image: '画像をアップロード中です。お待ちください...',
  toast_uploading_file: 'ファイルをアップロード中です。お待ちください...',
  toast_max_photos: '写真は最大{max}枚まで',
  toast_uploading: 'アップロード中です。お待ちください...',
  toast_file_too_large: '{name} が5MBの制限を超えています',
  toast_video_too_large: '{name} が20MBの制限を超えています',
  toast_video_processing: '動画を処理中です。お待ちください…',
  toast_upload_link_failed: 'アップロードリンクの取得に失敗しました',
  analyzing_image: '画像を分析中...',
  toast_location_confirmed: '位置情報を確認しました',
  toast_location_selected: '位置情報を選択しました',
  toast_enter_search: '検索内容を入力してください',
  toast_search_failed: '検索に失敗しました',
  toast_no_locations: '位置情報が見つかりません',
  toast_search_error: '検索に失敗しました。もう一度お試しください',
  toast_located_at: '現在地：{address}',
  toast_shared_finding: 'シェアしました！マッチを探しています...',
  toast_update_failed: '更新に失敗しました',
  toast_set_private: '非公開に設定しました',
  toast_no_matches: 'マッチが見つかりません',
  toast_matches_found: 'ベストマッチ{count}件を見つけました',
  toast_start_conversation_first: 'まず会話を始めてください',
  toast_load_history_failed: 'マッチ履歴の読み込みに失敗しました',
  toast_ai_timeout: 'AIの応答がタイムアウトしました。もう一度お試しください',
  toast_message_blocked: 'メッセージはブロックされました',
  network_disconnected: 'ネットワークが切断されました',
  toast_publish_success: 'ハブに投稿しました！',
  toast_publish_failed: 'ハブへの投稿に失敗しました',

  // ChatMsgList.vue
  collapse_thinking: '思考過程を折りたたむ',
  expand_thinking: '思考過程を展開',
  thinking: '思考中',
  select_date: '日付を選択',
  selected_location: '選択した位置',
  msg_blocked: 'ブロック済み',
  retry: '再試行',
  msg_read: '既読',
  msg_sent: '送信済み',
  msg_unread: '未読',
  label_start_datetime: '開始日時：',
  label_end_datetime: '終了日時：',
  toast_select_start_datetime: '開始日時を選択してください',
  toast_end_before_start: '終了日時は開始日時より後にしてください',
  report_message: 'メッセージを報告',
  block_user: 'ユーザーをブロック',
  msg_revoke: '送信取り消し',
  msg_quote: '引用',
  msg_revoked_self: 'メッセージを送信取り消しました',
  msg_revoked_other: '相手がメッセージを送信取り消しました',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'メッセージが送信取り消しされました',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'このメッセージは規約違反のためプラットフォームによって削除されました',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: '送信取り消ししました',
  toast_revoke_failed: '送信取り消しに失敗しました',
  toast_load_data_failed: 'データの読み込みに失敗しました。更新してください。',
  toast_file_url_missing: 'ファイルのURLが見つかりません',
  toast_block_success: 'ユーザーをブロックしました',
  toast_block_failed: 'ユーザーのブロックに失敗しました',

  // ChatSession.vue
  no_more_records: 'これ以上の記録はありません。',
  title_needs_clarified: '考えが明確になりました',
  title_clarifying: 'あなたの考えを整理しています',
  title_public: '公開',
  title_private: '非公開',
  badge_clarified: '明確化済み',
  badge_clarifying: '明確化中',
  badge_only_me: '非公開',
  badge_expired: '期限切れ',
  title_expired: '期限切れ',
  no_chat_history: 'チャット履歴がありません',

  // ContactMethods.vue
  block_status_banner: 'このユーザーをブロックしています',
  unblock_user: 'ブロック解除',
  toast_block_missing_id: 'ブロックできません：ユーザーIDがありません',
  dialog_block_confirm: '{name} をブロックしますか？相手からのメッセージは届かなくなります。',
  toast_user_blocked: '{name} をブロックしました',
  toast_unblock_missing_id: 'ブロック解除できません：ユーザーIDがありません',
  toast_user_unblocked: '{name} のブロックを解除しました',

  // BlockedUsers.vue
  blocked_users: 'ブロックしたユーザー',
  blocked_users_empty: 'ブロックしたユーザーはいません',
  blocked_users_empty_hint: 'ブロックしたユーザーからはメッセージが届かなくなります',
  blocked_users_unblock: 'ブロック解除',
  dialog_unblock_confirm: '解除すると、相手は再びあなたにメッセージを送れるようになります。',
  toast_unblock_success: 'ブロックを解除しました',
  toast_unblock_failed: 'ブロック解除に失敗しました。もう一度お試しください',
  blocked_users_load_failed: '読み込みに失敗しました。タップして再試行',
  blocked_users_blocked_at: '{date} にブロック',
  blocked_users_unknown_user: '不明なユーザー',

  // Contacts.vue
  no_connections: 'メッセージはまだありません',
  chat_with: '{name} とチャット',
  toast_load_contacts_failed: '連絡先の読み込みに失敗しました：{msg}',
  toast_load_contacts_error: '連絡先の読み込みに失敗しました。更新してもう一度お試しください。',
  time_just_now: 'たった今',
  time_minutes_ago: '{min}分前',
  time_hours_ago: '{hour}時間前',
  time_days_ago: '{day}日前',

  // InteractionNotification.vue
  interaction_notification_title: '通知',
  interaction_notification_subtitle: 'コメント & いいね',
  interaction_notification_empty: '通知はまだありません',
  interaction_notification_comment: 'コメントしました：{content}',
  interaction_notification_like: 'あなたの投稿にいいねしました',
  interaction_notification_reply: '返信しました：{content}',
  interaction_notification_bookmark: 'あなたの投稿をブックマークしました',
  toast_load_notifications_failed: '通知の読み込みに失敗しました：{msg}',
  toast_load_notifications_error: '通知の読み込みに失敗しました。更新してもう一度お試しください。',
  mark_all_read: 'すべて既読にする',
  toast_mark_all_read_failed: '操作に失敗しました。もう一度お試しください',
  contacts_dnd: '通知をミュート',
  dnd_enabled: '通知をミュートしました',
  dnd_disabled: '通知のミュートを解除しました',
  dnd_action_enable: '通知をミュート',
  dnd_action_disable: '通知のミュートを解除',

  // Discover.vue
  toast_load_sessions_failed: 'セッションの読み込みに失敗しました：{msg}',
  toast_load_sessions_error: 'セッションの読み込みに失敗しました',
  discover_noMessages: 'メッセージはまだありません',

  // EmojiInputArea.vue
  placeholder_default: 'AIにもっと詳しく教えて',
  userChat_typeMessage: 'メッセージを入力...',
  select_emoji: '絵文字を選択',
  badge_new: '新着',
  channel_search_placeholder: 'チャンネルを入力',
  channel_picker_empty: 'チャンネルを入力',

  // FrontPage.vue
  tab_chat_with_ai: 'OctoSay にあなたを理解してもらう',
  history_chats: '履歴',
  tab_connections: 'マッチ',
  tab_conversations: 'メッセージ',
  tab_profile: 'プロフィール',
  new_session: '新規',
  history_tab_chats: '自分の投稿',
  history_tab_matches: 'マッチ',
  channels_octosay: 'Octoグループ',
  tab_matches: 'マッチ',
  tab_messages: 'メッセージ',

  // Header.vue
  slogan: 'OctoSay - あなたを理解して、ぴったりの相手をつなぐAI',
  app_name: 'OctoSay',
  slogan_short: 'あなたを理解して、ぴったりの相手をつなぐAI',
  slogan_ai: 'あなたを理解して、ぴったりの相手をつなぐAI',
  get_the_app: 'アプリを入手',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'またはアプリストアで「OctoSay」を検索',

  // MapLocationPicker.vue
  placeholder_search_location: '位置情報を検索...',
  coords_display: '経度：{lng}、緯度：{lat}',
  toast_no_geolocation: 'お使いのブラウザは位置情報に対応していません',
  toast_location_permission_denied: '位置情報を取得できませんでした。位置情報の権限を確認してください',
  loading_address: '住所を読み込み中...',

  // MatchedSession.vue
  created_at: '作成日時：{time}',
  ai_match_analysis: 'AIのマッチ分析',
  error_missing_session_params: '必要なセッションパラメータがありません',
  match_private_hint: 'このセッションは非公開のため、内容は表示できません',

  // PersonalCenter.vue
  label_name: '名前：',
  placeholder_enter_name: '名前を入力してください',
  label_bio: '自己紹介：',
  placeholder_enter_bio: '自分について書いてみましょう',
  placeholder_bio_empty: '自分についてひとこと書いてみましょう',
  bio: '自己紹介',
  delete_account: 'アカウント削除',
  delete_warning: 'この操作は取り消せません。',
  delete_data_intro: '以下のデータが完全に削除されます：',
  delete_item_profile: 'プロフィール情報',
  delete_item_chat: 'チャット履歴とセッション',
  delete_item_contact: '連絡先情報',
  delete_item_all: 'すべての関連データ',
  final_confirmation: '最終確認',
  delete_confirm_prompt: '確認するには "delete" と入力してください：',
  placeholder_type_delete: 'delete と入力',
  private_token: 'プライベートトークン',
  token_desc: 'APIアクセス用のトークンを生成します',
  toast_not_logged_in: 'ユーザーがログインしていません',
  toast_name_required: '名前は必須です',
  toast_save_success: '保存しました',
  toast_save_failed: '保存に失敗しました',
  toast_image_too_large: '画像が5MBの制限を超えています',
  toast_avatar_updated: 'アイコンを更新しました',
  toast_avatar_failed: 'アイコンの更新に失敗しました',
  toast_upload_failed: 'アップロードに失敗しました',
  toast_token_generated: 'トークンを生成しました',
  toast_token_failed: 'トークンの生成に失敗しました',
  toast_copied: 'クリップボードにコピーしました',
  toast_copy_failed: 'コピーに失敗しました',
  toast_account_deleted: 'アカウントを削除しました',
  toast_delete_account_failed: 'アカウントの削除に失敗しました',
  toast_logout_success: 'ログアウトしました',
  toast_logout_failed: 'ログアウトに失敗しました',
  profile_tab_messages: 'メッセージ',
  profile_tab_comments: 'コメント',
  profile_tab_likes: 'いいね',
  profile_tab_bookmarks: 'ブックマーク',
  profile_empty_messages: 'メッセージはまだありません',
  profile_empty_comments: 'コメントはまだありません',
  profile_empty_likes: 'いいねはまだありません',
  profile_empty_bookmarks: 'ブックマークはまだありません',
  profile_reply_to: '{name} に返信',
  profile_stats_posts: 'メッセージ',
  profile_stats_comments: 'コメント',
  profile_stats_likes: 'いいね獲得数',
  profile_joined: '{date} に参加',

  // ReportDialog.vue
  report_message_title: 'メッセージを報告',
  report_reason_prompt: 'このメッセージを報告する理由を選択してください：',
  report_spam: 'スパム',
  report_harassment: '嫌がらせ・いじめ',
  report_inappropriate: '不適切なコンテンツ',
  report_other: 'その他',
  placeholder_report_desc: '問題の詳細（任意）',
  toast_select_reason: '理由を選択してください',
  toast_report_success: '報告を送信しました',
  toast_report_failed: '報告の送信に失敗しました',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[画像]',
  summary_images: '[画像x{count}]',
  summary_file: '[ファイル]',
  summary_files: '[ファイルx{count}]',
  summary_video: '[動画]',
  summary_videos: '[動画x{count}]',
  summary_location: '[位置情報]',
  summary_locations: '[位置情報x{count}]',
  summary_emoji: '[絵文字]',
  summary_emojis: '[絵文字x{count}]',
  summary_voice: '[ボイス]',
  summary_voices: '[ボイスx{count}]',
  summary_mixed: '[複数コンテンツ]',
  summary_other: '[その他]',

  // Voice messages
  voice: 'ボイス',
  voice_recording: '録音中...',
  toast_voice_too_short: '録音が短すぎます',
  toast_voice_failed: 'ボイスの送信に失敗しました',
  toast_mic_permission_denied: 'マイクにアクセスできません。ブラウザの設定で権限を有効にしてください',
  toast_recording_not_supported: 'このブラウザはボイス録音に対応していません',
  voice_load_failed: 'ボイスメッセージの読み込みに失敗しました',

  // Expire At
  aiChat_expireLine: '有効期限：{date}。いつでも AI に教えて更新できます',
  aiChat_expireExpired: 'コンテンツの有効期限が切れ、他の人には表示されなくなりました。いつでも AI に教えて期限を更新できます',

  // MatchedSession.vue
  detail: '詳細',

  // Match notification hints
  match_new_result_hint: '新しいマッチ結果が出たらメールで通知します。確実に受け取るには、アプリをインストールしてください。',

  // Match notification hints
  match_connection_notify_hint: 'マッチして通知しました！さっそく挨拶してみましょう！',
  match_continuousMatching: 'AIが継続的にマッチを探しています',
  match_continuousMatchingHint: '新しいマッチが見つかり次第、すぐにお知らせします',
  match_continuousMatchingOthers: 'AIが継続的にマッチを探しています',
  match_continuousMatchingOthersHint: '新しい結果はここに表示されます',
  match_noResultsTitleOthers: 'マッチを探しています',
  match_noResultsHintOthers: 'AIが継続的にマッチを探しています。見つかるとここに表示されます。',
  match_newMatchFound: '新しいマッチが{n}件見つかりました！',
  match_worth_exploring_hint: '連絡するかどうかはあなた次第です。',

  // Matches filter tags
  filter_all: 'すべて',
  filter_best_connection: 'ベストマッチ',
  filter_worth_a_look: '要チェック',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - あなたを理解して、ぴったりの相手をつなぐAI',
  landing_hero_title: 'ハブに書くだけ。AIが先に確認して、あなたが確認すると投稿してマッチします',
  landing_hero_subtitle: 'Octoグループ でシェアしたいメッセージを入力してください。公開前にAIがチャットで詳細を確認します。確認すると、メッセージとAIサマリーが一緒に投稿され、マッチングが始まります。',
  landing_download_on: 'ダウンロード：',
  landing_get_it_on: '入手：',
  landing_direct_download: '直接ダウンロード',
  landing_how_title: '使い方は3ステップ',
  landing_step1_title: 'ハブに投稿しよう',
  landing_step1_desc: 'ハブで共有したいメッセージを入力してください。AIがまずチャットで詳細を確認するので、すべての投稿が明確で役に立ち、マッチしやすい状態になります。雑談のノイズに埋もれません。',
  landing_step2_title: '確認して投稿、マッチへ',
  landing_step2_desc: '確認すると、元のメッセージとAIサマリーが一緒にハブへ投稿されます。その後AIが継続的に最適な相手を探すので、メッセージが埋もれて誰にも見られないことがありません。',
  landing_step3_title: 'つながってチャット',
  landing_step3_desc: 'マッチが見つかると、双方がAIとのチャット履歴とAIサマリーを確認できます。共通の文脈があるので、氷解も自然、会話もスムーズです。',
  // Comparison Section
  landing_comparison_title: 'なぜ OctoSay なのか？',
  landing_comparison_subtitle: 'ハブ型チャットだけど、AIが詳細を確認して積極的にマッチングします。',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'コンテンツの質',
  landing_cmp1_other: 'スパム・広告・脱線メッセージの氾濫',
  landing_cmp1_octo: 'AIが厳選したニーズカードのみ',
  landing_cmp2_label: '人探し',
  landing_cmp2_other: '投稿して返信を待つだけ',
  landing_cmp2_octo: 'AIが積極的にマッチング',
  landing_cmp3_label: 'ノイズの量',
  landing_cmp3_other: '何百ものメッセージをスクロール',
  landing_cmp3_octo: 'ノイゼロ。すべての投稿に意味がある',
  landing_cmp4_label: '始めやすさ',
  landing_cmp4_other: 'サーバーを探して、チャンネルを漁って、自力で覚える',
  landing_cmp4_octo: 'ハブに入力するだけ。AIが確認・マッチング',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: '小紅書',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'グループチャットは広告とスパムだらけ',
  landing_cmp1_xhs: '宣伝投稿ばかりで信じられない',
  landing_cmp1_facebook: '広告と釣り見出しがフィードを埋める',
  landing_cmp1_reddit: 'スパムと脱線投稿だらけ',
  landing_cmp2_wechat: '連絡先とグループ招待頼み',
  landing_cmp2_xhs: '自分で検索して投稿を漁る',
  landing_cmp2_facebook: '既存の友達とグループが限界',
  landing_cmp2_reddit: 'サブレディットを自分で探して返信を待つ',
  landing_cmp3_wechat: '何百ものグループメッセージをスクロール',
  landing_cmp3_xhs: 'フィードはレコメンドと広告だらけ',
  landing_cmp3_facebook: 'おすすめ投稿と広告が終わらない',
  landing_cmp3_reddit: '何百ものコメントをスクロール',
  landing_cmp5_label: '誰が探すのか',
  landing_cmp5_wechat: '一人ひとり聞いて運任せ',
  landing_cmp5_xhs: '投稿してコメントを待ち、自分でふるいにかける',
  landing_cmp5_facebook: 'グループであちこち聞き回る',
  landing_cmp5_reddit: '投稿して返信を待ち、さらにふるいにかける',
  landing_cmp5_octo: 'AIが自動で継続的に探してくれる',

  landing_features_title: '主な特徴',
  landing_feature1_title: '投稿前に確認',
  landing_feature1_desc: 'フォーム入力は不要。ハブにメッセージを書くと、AIが投稿前にチャットで質問して、あなたのニーズを本当に理解します。',
  landing_feature2_title: 'クリーンでカオスじゃない',
  landing_feature2_desc: 'メッセージとAIサマリーが一緒に投稿されます。OctoSayがすべての投稿を管理するので、スパムも脱線もノイズもありません。',
  landing_feature3_title: '先行型マッチング',
  landing_feature3_desc: 'あなたが確認してメッセージとAIサマリーが公開されると、AIがハブを継続的にスキャンし、お探しの条件に合う人を見つけて、その理由も説明します。',
  landing_feature4_title: 'トピックコミュニティ、ノイゼロ',
  landing_feature4_desc: 'スポーツ、ゲーム、言語交換、ルームメイトなど、トピックハブに参加。AIが投稿前にメッセージを確認するので、どのハブもクリーンで役に立ちます。',
  landing_feature5_title: 'プライバシー保護',
  landing_feature5_desc: '送信後にメッセージを非公開にでき、自分だけが見られる状態に。完全にコントロールできます。',
  landing_feature6_title: '意味のある会話',
  landing_feature6_desc: 'ノイズも雑然とした邪魔もなし。すべてのメッセージに意味があります。',
  landing_usecases_title: 'どんなシーンでも',
  landing_usecases_subtitle: '何を考えていても、トピックハブに参加するだけ。マッチングはAIにお任せ',
  landing_usecase_game: 'ゲーム仲間',
  landing_usecase_language: '言語交換',
  landing_usecase_skill: 'スキル交換',
  landing_usecase_roommate: 'ルームメイト探し',
  landing_usecase_travel: '旅の仲間',
  landing_usecase_sports: 'スポーツ仲間',
  landing_usecase_study: '勉強仲間',
  landing_usecase_anything: '...どんなことでもシェア',
  landing_cta_title: '始める準備はできましたか？',
  landing_cta_desc: 'トピックハブに参加して、シェアしたいことを書けば、AIが詳細を確認、あなたが確認すると投稿して、ぴったりの相手とマッチします。',
  landing_use_now: '今すぐ使う',
  landing_groups: 'ハブ',

  // OnboardingPage.vue
  onboarding_skip: 'スキップ',
  onboarding_next: '次へ',
  onboarding_getStarted: 'はじめる',
  onboarding_step1Title: "ハブで欲しいことを言おう",
  onboarding_step1Desc: "探していることややりたいことを、そのまま伝えてください。AIがチャットで詳細を確認し、伝わりやすいメッセージにまとめます。",
  onboarding_step2Title: '確認して投稿、マッチへ',
  onboarding_step2Desc: "メッセージがハブに投稿されたら、その後もAIがずっと最適な相手を探します。メッセージが埋もれて誰にも見られないことがありません。",
  onboarding_step3Title: 'つながってチャット',
  onboarding_step3Desc: "お互いがAIとのチャット内容を見られるので、相手が何を探しているか分かります。共通の文脈があるから、氷解も自然、会話もスムーズです。",

  // ChannelDetail.vue
  channel_image_limit: '画像は1枚まで',

  // ChannelMembers.vue
  channel_members_empty: 'メンバーはまだいません',
  channel_members_title: 'メンバー',
  channel_role_owner: 'オーナー',
  channel_role_admin: '管理者',
  channel_role_member: 'メンバー',

  // Settings.vue
  settings_language: '言語',
  settings_language_followSystem: 'システムに合わせる',

  // ChatBox.vue
  match_interested_suffix: '、{count}件が要チェック',

  // ChatBox.vue - AIマッチング進行ステージ
  match_stage_fetch_chat: '会話を取得',
  match_stage_query_expansion: 'クエリを拡張',
  match_stage_semantic_search: '意味検索',
  match_stage_deep_search: '深層分析',
  match_stage_rerank: '智能マッチング',
  match_stage_refining: '結果を最適化',
  match_stage_fetch_details: '詳細を取得',

  // ChannelDetail.vue - 画像アップロード
  channel_select_image: '画像ファイルを選択してください',
  channel_image_upload_failed: '画像のアップロードに失敗しました。もう一度お試しください',
  chatInput_channelSearchHint: "グループを検索",
}



// WEBPACK FOOTER //
// ./src/i18n/ja.js